var map = {
	"./flags/be.svg": 26,
	"./flags/cn.svg": 27,
	"./flags/de.svg": 28,
	"./flags/es.svg": 29,
	"./flags/fr.svg": 30,
	"./flags/gb.svg": 31,
	"./flags/it.svg": 32,
	"./flags/jp.svg": 33,
	"./flags/us.svg": 34,
	"./icons/back.svg": 35,
	"./icons/close.svg": 36,
	"./icons/download.svg": 37,
	"./icons/entity-color.svg": 38,
	"./icons/entity-date.svg": 39,
	"./icons/entity-density.svg": 40,
	"./icons/entity-features.svg": 41,
	"./icons/entity-grapes.svg": 42,
	"./icons/entity-localisation.svg": 43,
	"./icons/entity-soil.svg": 44,
	"./icons/entity-surface.svg": 45,
	"./icons/error.svg": 46,
	"./icons/facebook.svg": 47,
	"./icons/info.svg": 48,
	"./icons/instagram.svg": 49,
	"./icons/linkedin.svg": 50,
	"./icons/marker.svg": 51,
	"./icons/scroll-down.svg": 52,
	"./icons/slider-arrow.svg": 53,
	"./icons/success.svg": 54,
	"./icons/tiktok.svg": 55,
	"./icons/twitter-x.svg": 56,
	"./icons/twitter.svg": 57,
	"./icons/weibo.svg": 58,
	"./icons/whatsapp.svg": 59,
	"./icons/wine-accords.svg": 60,
	"./icons/wine-bouche.svg": 61,
	"./icons/wine-cepages.svg": 62,
	"./icons/wine-nez.svg": 63,
	"./icons/wine-robe.svg": 64,
	"./icons/youtube.svg": 65,
	"./line.svg": 66,
	"./logo-full.svg": 67,
	"./logo.png": 68,
	"./logo.svg": 69,
	"./marker.png": 70,
	"./pattern.png": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;